import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { IntegratedAdmissionAppointmentObservation } from "src/app/model/integrated-admission/integrated-admission-appointment-observation";
import { IntegratedAdmissionWizardService } from "../../service/integrated-admission-wizard.service";
import { PracticeRegionPreparationDialogComponent } from "src/app/components/dialogs/practice-region-preparation/practice-region-preparation-dialog.component";
import { MatDialog } from "@angular/material";
import { Subscription } from "rxjs";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import { DiagnosticFilter } from "src/app/model/diagnostic-filter";
import { DiagnosticService } from "src/app/services/diagnostic.service";

@Component({
  selector: "app-integrated-admission-appointment-observation",
  templateUrl: "./integrated-admission-appointment-observation.component.html",
  styleUrls: ["./integrated-admission-appointment-observation.component.css"],
})
export class IntegratedAdmissionAppointmentObservationComponent
  implements OnInit, OnDestroy
{
  requiredCIEDiagnosis: boolean = false;
  isPreAdmission: boolean;
  form: FormGroup;
  onChange;
  allDiagnosis: DiagnosticFilter[] = [];
  currentAppointmentSubscription: Subscription;
  validationSubscription: Subscription;
  filterCompleteautDiagnosisCIE: FilterCompleteService<DiagnosticFilter>;
  readonlySubscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private service: IntegratedAdmissionWizardService,
    private diagnosticService: DiagnosticService,
    public dialog: MatDialog
  ) {
    this.form = this.formBuilder.group({
      AppointmentDate: [null],
      Observation: [null],
      ObservationPatient: [null],
      Diagnosis: [null],
      DiagnosisCIE: [null],
      IsInternation: [false],
      AppointmentDateRequired: [false],
    });

    this.filterCompleteautDiagnosisCIE =
      new FilterCompleteService<DiagnosticFilter>(
        [],
        this.form.controls.DiagnosisCIE
      );

    this.subscribeEvents();
  }

  ngOnDestroy(): void {
    if (this.currentAppointmentSubscription)
      this.currentAppointmentSubscription.unsubscribe();
    if (this.validationSubscription) this.validationSubscription.unsubscribe();
  }

  async openPreparationDialog() {
    const dialogRef = this.dialog.open(
      PracticeRegionPreparationDialogComponent,
      {
        width: "70%",
        data: this.service.getAllCurrnetProcedureIds(),
      }
    );
  }

  async ngOnInit() {
      if (this.allDiagnosis.length === 0) {
          this.allDiagnosis =
            await this.diagnosticService.getDiagnosticsFilter();
        }
  }

  private subscribeEvents() {
    this.readonlySubscription = this.service.currentReadOnlySubject$.subscribe(
      (readOnly) => {
        if (readOnly) {
          if (readOnly) {
            this.form.disable();
          }
        }
      }
    );

    this.currentAppointmentSubscription =
      this.service.currentAdmissionAppointment$.subscribe((appointment) => {
        if (appointment) {


          this.form.patchValue(appointment.Observation);
          this.isPreAdmission = appointment.Observation.AppointmentDateRequired;

          const diagnoses = this.allDiagnosis.filter(
            (d) => d.CodeMode === appointment.Plan.Entity.DiagnosisCodeMode
          );

          if (appointment.MedicalOrderEdit.MedicalOrder.DiagnosisId) {
            appointment.Observation.DiagnosisCIE = diagnoses.find(
              (d) =>
                d.Id === appointment.MedicalOrderEdit.MedicalOrder.DiagnosisId
            );

            this.form.patchValue({
              DiagnosisCIE: appointment.Observation.DiagnosisCIE,
            });
          }
        }
      });

    this.validationSubscription =
      this.service.currentValidationSubject$.subscribe(async (validation) => {
        if (this.allDiagnosis.length === 0) {
          this.allDiagnosis =
            await this.diagnosticService.getDiagnosticsFilter();
        }

        this.requiredCIEDiagnosis = validation.RequiredCIEDiagnosis;

        const diagnos = this.allDiagnosis.filter(
          (d) => d.CodeMode === validation.DiagnosisCodeMode
        );

        this.filterCompleteautDiagnosisCIE =
          new FilterCompleteService<DiagnosticFilter>(
            diagnos,
            this.form.controls.DiagnosisCIE
          );
      });

    this.form.valueChanges.subscribe((value) => {
      this.service.setObservation(value);
    });
  }

  get filteredDiagnosesCIEOptions() {
    return this.filterCompleteautDiagnosisCIE
      ? this.filterCompleteautDiagnosisCIE.filteredOptions
      : [];
  }
}
